import React from 'react';
import EnquetePage from './pages/EnquetePage';
import { initializeGA } from './utils/GoogleAnalyticsUtil';
function App() {
    initializeGA('G-C2VB19SCSV', 'UA-207543448-1', 'OPT-NMB2BC5');
    return React.createElement(EnquetePage, null);
}
export default App;
